<template>
  <div class="text-primaryDark">
    <transition name="fade">
      <div v-if="isIdle" class="bg-black fixed bg-opacity-80 inset-0 toppest flex items-center justify-center">
        <div class="bg-white sm:w-1/3 w-11/12 px-8 py-8 shadow-2xl rounded-md text-center">
          <img class="h-14 mx-auto mb-4" src="@/assets/icons/expired.png" />
          <p class="text-center text-2xl font-semibold mb-3">
            Your session has expired
          </p>
          <p class="text-center text-sm leading-relaxed">
            Your session has expired due to inactivity. You will need to login again.
          </p>
          <div class="w-full flex justify-center mt-6">
            <button @click="goToLogin" class="text-sm bg-buttonColor hover:bg-primary text-white w-36 p-2 rounded-full font-medium">
              Login
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Expired",
  computed: {
    ...mapGetters(["getUser"]),
  },
  data() {
    return {
      isIdle: false,
    };
  },
  mounted() {
    console.log(this.$route.name);
  },
  onIdle() {
    this.isIdle = true;
    const org = this.$route.params.organization;
    this.$store.commit("logout");
    if (org) {
      this.$store.commit("setOrganization", org);
    }
  },
  methods: {
    goToLogin() {
      this.$router.replace({ name: "login" });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.toppest{
  z-index: 99999999;
}
</style>